import colors from './colors.js';
import flexbox from './flexbox.js';
import variables from './variables.js';
import breakpoints from './breakpoints.js';
import typography from './typography.js';

const theme = {
  colors: colors,
  variables: variables,
  flexboxgrid: flexbox,
  breakpoints: breakpoints,
  typography: typography,
};

export default theme;
